import { useQuery } from 'react-query';

import { getUsersPageData } from 'api/users/getUsersPageData';

export const useGetUsersPageData = (table_name: string) => {
  const { data, refetch, isLoading, isFetching } = useQuery(
    ['UsersPageData', table_name],
    () => getUsersPageData(table_name),
    {
      refetchOnWindowFocus: false,
    },
  );

  return { data, refetch, isLoading, isFetching };
};

export default useGetUsersPageData;
